import { getRequest, postRequest, putRequest } from "api/axiosClient";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/quick-request`;

const cancelQuickRequest = (id) => putRequest(`${baseURL}/${id}/cancel`);
const convertQuickRequest = (id) => postRequest(`${baseURL}/${id}/convert-to-quote-request`, {});
const duplicateQuickRequest = (id) => postRequest(`${baseURL}/${id}/duplicate`);
const getQuickRequestComments = (id) => getRequest(`${baseURL}/${id}/comments`);
const getQuickRequestDetails = (id) => getRequest(`${baseURL}/${id}`);
const getQuickRequests = (config = {}) => getRequest(`${baseURL}s`, config);
const postQuickRequestComment = (id, payload) => postRequest(`${baseURL}/${id}/comments`, payload);
const requestQuickRequestCancellation = (id) => putRequest(`${baseURL}/${id}/request-to-cancel`);
const startEditQuickRequest = (id) => postRequest(`${baseURL}/start-edit-quick-request/${id}`);
const importQuickRequest = (payload, config = {}) => postRequest(`${baseURL}/import`, payload, config);
const getQuickRequestsByIds = (payload = {}) => postRequest(`${baseURL}/get-by-ids`, payload);
const getQuickRequestShipmentDetails = (id) => getRequest(`${baseURL}/shipment/${id}`);
const downloadAllQuickRequestAttachments = (id) =>
  getRequest(`${baseURL}/${id}/download-all-attachments`, {
    responseType: "blob",
  });

export {
  cancelQuickRequest,
  convertQuickRequest,
  duplicateQuickRequest,
  getQuickRequestComments,
  getQuickRequestDetails,
  getQuickRequests,
  postQuickRequestComment,
  requestQuickRequestCancellation,
  startEditQuickRequest,
  importQuickRequest,
  getQuickRequestsByIds,
  getQuickRequestShipmentDetails,
  downloadAllQuickRequestAttachments,
};
